module.exports = __webpack_public_path__ + "static/media/agentIcon.41837e7b.svg";